import {
  REGISTRATION_FEEDBACK_PLATFORM,
  REGISTRATION_FEEDBACK_SURVEY_TRIGGER,
  type RegistrationFeedbackApiPayload,
  type RegistrationFeedbackMetadata,
} from "./registrationFeedback.types";

export function buildRegistrationFeedbackPayload(
  metadata: RegistrationFeedbackMetadata,
  rating: number,
  comment = "",
): Omit<RegistrationFeedbackApiPayload, "OS" | "Device"> {
  return {
    QID1: rating,
    QID9_TEXT: comment.trim(),
    UserUUID: metadata.userUUID,
    LoanNumber: metadata.loanNumber,
    SurveyTrigger: REGISTRATION_FEEDBACK_SURVEY_TRIGGER,
    Platform: REGISTRATION_FEEDBACK_PLATFORM,
    Email: metadata.email,
  };
}
